// ARCHX AI — Shared upload-category config
// Single source of truth for the case upload boxes, used by BOTH the New Case
// page and the Edit Case (add/modify scans) page so they can never drift apart.

export const UPLOAD_CATEGORIES = [
  { key: 'preop2d',        label: 'Pre-Op 2D Photos or 3D Facial Scan (.obj)',        required: false },
  { key: 'preop3d',        label: 'Pre-Op 3D IOScans (Trios, iTero, Shining, others)', required: false },
  { key: 'cbct',           label: 'CBCT / Cone Beam (DICOM)',                          required: false,
    accept: '.dcm,.dicom,.zip',
    hint: 'Upload the 3D cone-beam volume — a .zip of the full DICOM series, or select all the .dcm slices. Large files are supported.' },
  { key: 'waxup',          label: 'Digital Wax-up Pre-Op (optional)',                 required: false },
  { key: 'surgical',       label: 'Pre-Surgical Scans w/ Fiducial Markers',           required: false },
  { key: 'photogrammetry', label: 'Post Surgical Photogrammetry Data',                 required: false },
  { key: 'postop',         label: 'Post Surgical IOScans w/ Scan Caps / Tissue Scan / Fiducial Marker', required: false },
  { key: 'stlAligned',     label: 'STL Aligned Files / Exocad STL',                  required: false },
  { key: 'stlProvisional', label: 'STL Temp Provisional Design',                      required: false },
  { key: 'revisions',      label: 'Additional Designs w/ Revisions',                  required: false },
];

// Default file types accepted across categories.
export const DEFAULT_ACCEPT = '.stl,.jpg,.jpeg,.png,.dcm,.obj,.ply';

// CBCT is volumetric DICOM — restrict to DICOM slices or a zipped series, and cap size.
export const CBCT_EXTS = ['.dcm', '.dicom', '.zip'];
export const MAX_CBCT_BYTES = 2 * 1024 * 1024 * 1024; // 2 GB per file

export function isCbctFile(file) {
  const n = file.name.toLowerCase();
  return CBCT_EXTS.some(ext => n.endsWith(ext)) && file.size <= MAX_CBCT_BYTES;
}

// Filter a list of files for the CBCT category, warning on anything skipped.
export function filterCbctFiles(files) {
  const ok = [], bad = [];
  files.forEach(f => (isCbctFile(f) ? ok : bad).push(f));
  if (bad.length) {
    alert(
      `Skipped ${bad.length} file(s) for CBCT. Only DICOM (.dcm/.dicom) or a .zip ` +
      `of the series is accepted, up to 2 GB each:\n\n` +
      bad.map(f => `• ${f.name}`).join('\n')
    );
  }
  return ok;
}
